import React from 'react'
import DiagnosisSelect from "./DiagnosisSelect"
import DoctorConfirm from "./DoctorConfirm"
import ThankYou from "../../ThankYou"
import Custom from "./Custom"

class Tagging extends React.Component {
  componentDidUpdate() {
    if (this.props.doctor || this.props.diagnosis === "Unsure") {
      this.props.finishTagging()
    }
  }

  render() {
    return (
      <React.Fragment>
        <DiagnosisSelect
          {...this.props}
          first
          somethingElse
          unsure
        />
        {this.props.diagnosis === "Something else" && <Custom {...this.props} />}
        {(typeof this.props.diagnosis === "number" || this.props.customSubmitted) && <DoctorConfirm {...this.props} />}
        {this.props.finished && <ThankYou/>}
      </React.Fragment>
    )
  }
}

export {Tagging as default}



// WEBPACK FOOTER //
// ./assets/feedback/components/tagging/components/Tagging.js